// extracted by mini-css-extract-plugin
export default {"containerFixed":"ContainerWhite_containerFixed__lxnjC","shadow-sm":"ContainerWhite_shadow-sm__+t5Nl"};